import React, { memo } from "react";
import { StModuleContainer } from "@mediamath/design-system-eng";
import NavRoutes from "core/app/util/NavRoutes";
import Route from "core/shared/presenter/Route";
import SmartSwitch from "core/shared/util/SmartSwitch";
import ReportsModuleTabs from "reports/ReportsModuleTabs";

export const tabRoutes = [
  NavRoutes.reports.default,
  NavRoutes.reports.dataExport,
];

const ReportsModule = memo(() => {
  return (
    <StModuleContainer>
      <SmartSwitch>
        <Route component={ReportsModuleTabs} exact path={tabRoutes} />
      </SmartSwitch>
    </StModuleContainer>
  );
});

export default ReportsModule;
